import { z } from 'zod';

// Super-admin enrichment-provider routing: the ORDERED provider waterfall
// serving each enrichment slot (e.g. ['internal','cleanlist'] — no-match
// falls through in order), globally or per-org. `organization_id = '*'` is
// the global default row. snake_case = the wire contract.
//
// `id` is a plain string (not z.uuid()) because the admin UI inserts an
// optimistic row with a synthetic id while a write is in flight.
export const providerConfigSchema = z.object({
  id: z.string(),
  organization_id: z.string(),
  slot: z.string(),
  providers: z.array(z.string()),
  enabled: z.boolean(),
});
export type ProviderConfig = z.infer<typeof providerConfigSchema>;

// GET /admin/provider-config payload (the `data` object inside SuccessResponse).
// `available_providers` lists, per slot, the provider ids that are actually
// routable right now (env-configured) — the UI greys out the rest.
// `known_providers` / `default_providers` are the backend registry itself, so
// the UI's picker can't drift from the ids a slot actually accepts.
export const providerConfigListResponseSchema = z.object({
  provider_config: z.array(providerConfigSchema),
  available_providers: z.record(z.string(), z.array(z.string())).optional(),
  known_providers: z.record(z.string(), z.array(z.string())).optional(),
  default_providers: z.record(z.string(), z.array(z.string())).optional(),
});
export type ProviderConfigListResponse = z.infer<
  typeof providerConfigListResponseSchema
>;
